module.exports = __webpack_public_path__ + "assets/img/coverbox.f43157fb.svg";